import React, { useRef, useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { SplitButton } from "primereact/splitbutton";
import { settingService } from "../../../services/extensions";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import DepartmentForm from "./department-form";
import { confirmDialog } from "primereact/confirmdialog";
import ImportPopup from "../importpopup/importPop";
import { InputText } from "primereact/inputtext";
import { Util } from "../../../services";

function Department() {
    const dt = useRef(null);
    const [department, setDepartment] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [departmentDialog, setDepartmentDialog] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [importDialog, setImportDialog] = useState(false);

    useEffect(() => {
        getDepartment();
    }, []);

    const getDepartment = () => {
        settingService.getDepartment().then((resp) => {
            setDepartment(resp.data.data);
        });
    };

    const addDepartment = () => {
        setDepartmentDialog(true);
    };

    const editRowComplete = (e) => {
        let _department = [...department];
        let { newData, index } = e;
        _department[index] = newData;

        let param = {
            id: _department[index].id,
            code: _department[index].code,
            title: _department[index].title,
            status: _department[index].status,
        };

        try {
            settingService.updateDepartment(param).then(
                (resp) => {
                    if (resp) {
                        toast.success("Department updated successfully!");
                        getDepartment();
                    }
                },
                (err) => {
                    toast.error("Unable to update Department");
                }
            );
        } catch (error) {
            toast.error("Unable to update Department");
        }
    };
    const onHide = () => {
        setDepartmentDialog(false);
    };
    const onHideImport = () => {
        setImportDialog(false);
    };

    const closeEntityDialoge = () => {
        setDepartmentDialog(false);
        getDepartment();
    };

    const NewDepartmentDialog = () => {
        return (
            <Dialog
                // style={{ width: "30vw" }}
                className="modal_width"
                header="Add Department"
                visible={departmentDialog}
                onHide={() => onHide()}>
                <DepartmentForm
                    onClose={(e) => {
                        closeEntityDialoge();
                    }} />
            </Dialog>
        );
    };
    const onCheckDepartment = (e) => {
        setSelectedDepartment(e.value);
        if (e.value.length > 0) {
            setDisabled(false);
        }
    };

    /* FOR CONFIRMATION DIAGOG BOX */
    const [isConfirmDialogVisiable, setIsConfirmDialogVisiable] = useState(false);
    const reject = () => {
        setIsConfirmDialogVisiable(true);
    };
    /* FOR CONFIRMATION DIALOG BOX */

    //multipul delete start
    const deleteConfirm = () => {
        confirmDialog({
            message: "Do you want to delete this record?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            acceptLabel: "No",
            rejectLabel: "Yes",
            accept: () => { },
            reject: () => acceptFunc(),
        });
    };

    const acceptFunc = () => {
        var depamenttIdList = [];
        selectedDepartment.map((item, key) => {
            depamenttIdList[key] = item.id;
        });
        let param = {
            Ids: depamenttIdList,
        };
        try {
            settingService.deletemultipaledepartment(param).then(
                (resp) => {
                    toast.success("Department deleted");
                    setSelectedDepartment([]);
                    getDepartment();
                },
                (err) => {
                    toast.error(err.response.data.error);
                    setSelectedDepartment([]);
                }
            );
        } catch (error) {
            toast.error("Unable to delete legal entiry");
        }
    };
    //multipul delete end
    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button
                    label="New"
                    icon="pi pi-plus"
                    className="p-button mr-2"
                    onClick={() => addDepartment()}
                ></Button>
                <Button
                    type="button"
                    label="Delete"
                    icon="pi pi-trash"
                    className="p-button-danger"
                    disabled={disabled}
                    onClick={deleteConfirm}
                ></Button>
            </React.Fragment>
        );
    };
    // delete department by row start
    const deleteLegalEntityByRow = (row) => {
        return (
            <React.Fragment>
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger"
                    onClick={(e) => deleteDepartment(e, row)}
                ></Button>
            </React.Fragment>
        );
    };
    const deleteDepartment = (e, row) => {
        confirmDialog({
            target: e.currentTarget,
            message: "Are you sure you want to delete?",
            header: "Delete Confirmation",
            icon: "pi pi-exclamation-triangle",
            acceptLabel: "No",
            rejectLabel: "Yes",
            reject: () => {
                settingService.deleteDepartmentById(row.id).then(
                    (resp) => {
                        toast.success("Department deleted successfully!");
                        getDepartment();
                    },
                    (error) => { }
                );
            },
            accept: () => { },
        });
    };
    // delete department by row end
    const OpenimportDialog = () => {
        return (
            <Dialog
                className="pop-up-dialog"
                header="Import"
                footer={<Button label="Submit"></Button>}
                visible={importDialog}
                onHide={() => onHideImport()}>
                <ImportPopup
                    onClose={(e) => {
                        setImportDialog(false);
                    }}
                    type="legalEntity" />
            </Dialog>
        );
    };
    const onClickDeallocation = (rowData) => {
        setImportDialog(true);
    };
    const exportCSV = () => {
        dt.current.exportCSV(department, "Department");
    };
    const exportExcel = () => {
        Util.exportExcel(department, "Department");
    };

    const cols = [
        { field: "id", header: "Id" },
        { field: "code", header: "Code" },
        { field: "title", header: "Title" },
        { field: "status", header: "Status" },
    ];
    const exportColumns = cols.map((col) => ({
        title: col.header,
        dataKey: col.field,
    }));

    const exportPdf = () => {
        Util.exportAsPdf(exportColumns, department, "Department");
    };
    const items = [
        {
            label: "CSV",
            icon: "pi pi-file-export",
            command: () => {
                exportCSV();
            },
        },
        {
            label: "EXCEL",
            icon: "pi pi-file-excel",
            command: () => {
                exportExcel();
            },
        },
        {
            label: "PDF",
            icon: "pi pi-file-pdf",
            command: () => {
                exportPdf();
            },
        },
    ];

    const rightToolbarTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button
                    label="Import"
                    icon="pi pi-plus"
                    className="mr-2"
                    onClick={() => {
                        onClickDeallocation(rowData);
                    }} />
                <SplitButton
                    label="Export"
                    icon="pi pi-download"
                    className="p-button-info"
                    model={items}
                    appendTo="self" />
            </React.Fragment>
        );
    };

    const codeEditor = (options) => {
        return (
            <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.toUpperCase())}></InputText>
        );
    };
    const titleEditor = (options) => {
        return (
            <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1))}></InputText>
        );
    };

    const fetchStatus = (status) => {
        if (status === 0) return "INACTIVE";
        if (status === 1) return "ACTIVE";
        if (status === 2) return "REJECT";
        if (status === 3) return "UPCOMING";
        if (status === 4) return "ARCHIVE";
    };
    const fetchStatusColor = (status) => {
        if (status === 0) return "red";
        if (status === 1) return "#008000";
        if (status === 2) return "red";
        if (status === 3) return "#cb7205";
        if (status === 4) return "rgb(222 204 90)";
    };

    const statusBodyTemplate = (data) => {
        return (
            <span style={{ color: fetchStatusColor(data.status), borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchStatus(data.status)}</span>
        );
    };
    const statuses = [
        { label: "INACTIVE", value: 0 },
        { label: "ACTIVE", value: 1 },
        { label: "ARCHIVE", value: 4 },
    ];
    const statusEditor = (options) => {
        return (
            <Dropdown
                value={options.value}
                options={statuses}
                optionLabel="label"
                optionValue="value"
                onChange={(e) => options.editorCallback(e.value)}
                placeholder="Select a Status"
                itemTemplate={(option) => {
                    return (
                        <span className={`product-badge status-${option.label.toLowerCase()}`}>{option.label}</span>
                    );
                }} />
        );
    };


    return (
        <div>
            <Toolbar
                className="mb-2"
                left={leftToolbarTemplate}
                right={rightToolbarTemplate}
            ></Toolbar>
            <div className="grid">
                <div className="col-12">
                    <DataTable
                        value={department}
                        paginator
                        responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rows={10}
                        rowsPerPageOptions={[10, 20, 50]}
                        dataKey="id"
                        editMode="row"
                        onRowEditComplete={editRowComplete}
                        ref={dt}
                        selectionMode="checkbox"
                        selection={selectedDepartment}
                        onSelectionChange={(e) => onCheckDepartment(e)}
                    >
                        <Column
                            selectionMode="multiple"
                            headerStyle={{ width: "3rem" }}
                            exportable={false}
                        ></Column>
                        <Column
                            field="code"
                            header="Code"
                            headerStyle={{ width: "8rem" }}
                            editor={(options) => codeEditor(options)}
                            sortable
                        ></Column>
                        <Column
                            field="title"
                            header="Title"
                            headerStyle={{ width: "8rem" }}
                            sortable
                            editor={(options) => titleEditor(options)}
                        ></Column>
                        <Column
                            field="status"
                            header="Status"
                            body={statusBodyTemplate}
                            editor={(options) => statusEditor(options)}
                            style={{ width: "20%" }}
                        ></Column>
                        <Column
                            rowEditor
                            headerStyle={{ width: "10%", minWidth: "8rem" }}
                            bodyStyle={{ textAlign: "right" }}
                        ></Column>
                        <Column
                            style={{ minWidth: "8rem" }}
                            body={deleteLegalEntityByRow}
                            exportable={false}
                            rowEditor
                            headerStyle={{ width: "10%", minWidth: "8rem" }}
                        ></Column>
                    </DataTable>
                </div>
            </div>
            {OpenimportDialog()}
            {NewDepartmentDialog()}
        </div>
    );
}
export default Department;